import React from "react";
import { CheckOnlyIcon } from "./icons";

const STEP_COUNT = 3;

export default function Stepper({ currentStep, onStepClick }) {
  const steps = Array.from({ length: STEP_COUNT }, (_, i) => i + 1);

  return (
    <ol className="onboarding__stepper">
      {steps.map((step, index) => {
        const isDone = step < currentStep;
        const isActive = step === currentStep;
        const clickable = isDone;

        return (
          <React.Fragment key={step}>
            <li className={`onboarding__step${isActive ? " is-active" : ""}${isDone ? " is-done" : ""}`}>
              <span
                className="onboarding__step-circle"
                role={clickable ? "button" : undefined}
                tabIndex={clickable ? 0 : undefined}
                onClick={clickable ? () => onStepClick(step) : undefined}
              >
                {isDone ? <CheckOnlyIcon /> : step}
              </span>
            </li>
            {index < steps.length - 1 && (
              <li className={`onboarding__step-line${step < currentStep ? " is-done" : ""}`} aria-hidden="true" />
            )}
          </React.Fragment>
        );
      })}
    </ol>
  );
}
